import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class AppGlobal {
  constructor() {}

  localUrl: string = "/";
  // localUrl: string = "https://Company-sd.com";
  lang: string = "ar";
  title: string = "Company Information Technology";
  conId: string = "0";
  codeError: number = 404;
  titleErrorAr: string = "نأسف!";
  msgErrorAr: string = "الصفحة غير موجودة";
  titleErrorEn: string = "Oops!";
  msgErrorEn: string = "This is not the web page you are looking for...!";
}
